<template>
  <v-tooltip
    top
    color="#e9c46a"
    open-on-hover
    open-delay="250"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs" />
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SabiraTooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.v-tooltip__content {
  color: black;
  opacity: 1;
  font-size: 12px;
  padding: 4px 8px;
}

.v-tooltip__content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #e9c46a transparent transparent transparent;
}</style
>cla
